module.exports = __webpack_public_path__ + "files/8d5942672e4908ac89835acd604ad9e9.png";